import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type SwitchHorizontal02IconProps = IconProps

const SwitchHorizontal02Icon = forwardRef<
  SVGSVGElement,
  SwitchHorizontal02IconProps
>((props: SwitchHorizontal02IconProps, ref) => (
  <Icon {...props} ref={ref}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 17h16m0 0-4-4m4 4-4 4m4-14H4m0 0 4-4M4 7l4 4"
      fill="none"
    ></path>
  </Icon>
))

SwitchHorizontal02Icon.displayName = 'SwitchHorizontal02Icon'
SwitchHorizontal02Icon.defaultProps = iconDefaultProps

export type { SwitchHorizontal02IconProps }
export { SwitchHorizontal02Icon }
